export const SET_STANDINGS = 'SET_STANDINGS';
export const SET_LOADING = 'SET_LOADING';
export const SET_CURRENT_SEASON = 'SET_CURRENT_SEASON';
export const SET_CURRENT_TOURNAMENT = 'SET_CURRENT_TOURNAMENT';
export const SET_SEASONS = 'SET_SEASONS';
export const SET_GAMES = 'SET_GAMES';

export const setStandings = (standings) => ({
  type: SET_STANDINGS,
  payload: standings
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading
});

export const setCurrentSeason = (season) => ({
  type: SET_CURRENT_SEASON,
  payload: season
});

export const setCurrentTournament = (tournament) => ({
  type: SET_CURRENT_TOURNAMENT,
  payload: tournament
});

export const setSeasons = (seasons) => ({
  type: SET_SEASONS,
  payload: seasons
});

export const setGames = (games) => ({
  type: SET_GAMES,
  payload: games
});
